<template>
    <router-link to="/" class="logo">
        <img src="/static/img/logo2.png" alt="Madya Online Courses | آموزش های آنلاین مادیا">
    </router-link>
</template>

<script>
export default {
    name: 'logo'
}
</script>
<style lang="less" scoped>
 .logo {
    display: block;
    padding: 0;
    width: 60px;
    img {
      width: 100%;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/ui/logo/index.vue